import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import Swipe from 'swipe-js-iso';

const ORGANISM_NAME = 'carousel';

export default class Carousel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
      autoPlay: props.options.auto,
      numSlides: props.children.length,
      isTransitioning: false,
      isLoading: true,
    };

    this.next = this.next.bind(this);

    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);

    this.slideTo = this.slideTo.bind(this);
    this.swiping = this.swiping.bind(this);
    this.transitionEnd = this.transitionEnd.bind(this);

    this.pauseSlide = this.pauseSlide.bind(this);
    this.resumeSlide = this.resumeSlide.bind(this);
    this.stopAutoPlay = this.stopAutoPlay.bind(this);

    this.setTabIndex = this.setTabIndex.bind(this);
    this.handleFirstTab= this.handleFirstTab.bind(this);

    this.handleInitialLoad = this.handleInitialLoad.bind(this);
  }

  componentDidMount() {
    this.handleInitialLoad();
    window.addEventListener('keydown', this.handleFirstTab);
  }

  componentDidUpdate() {
    this.setTabIndex();
  }

  componentWillUnmount() {
    if (this.swipe) {
      this.swipe.kill();
    }
    this.swipe = undefined;
    clearTimeout(this.timeout);
    window.removeEventListener('keydown', this.handleFirstTab);
  }
   /* eslint-disable */
  handleFirstTab(e) {
    if (e.keyCode === 9) { // the "I am a keyboard user" key
      document.body.classList.add('user-is-tabbing');
    }
  }
 /* eslint-enable */
  setTabIndex() {
    const activeSlide = `[data-index="${this.state.currentSlide}"]`;
    const inactiveSlides = `.carousel__wrapper > :not([data-index="${this.state.currentSlide}"])`;
    const tabableElements = 'a, area, button, input, object, select, textarea';
    const inactiveSlidesArr = [...this.refs.container.querySelectorAll(inactiveSlides)];
    const activeSlidesArr = this.refs.container.querySelectorAll(activeSlide);

    inactiveSlidesArr.forEach(e => {
      const inactiveElementsArr = [...e.querySelectorAll(tabableElements)];

      inactiveElementsArr.forEach(el => {
        const element = el;
        element.tabIndex = '-1';
      });
    });

    if (activeSlidesArr.length) {
      const activeElementsArr = [...activeSlidesArr[0].querySelectorAll(tabableElements)];
      activeElementsArr.forEach(el => {
        const element = el;
        element.tabIndex = '0';
      });
    }
  }

  getNumSlides() {
    return this.swipe.getNumSlides();
  }

  getPos() {
    return this.swipe.getPos();
  }

  setPos() {
    this.setState({
      currentSlide: this.getPos(),
    });
  }

  initCarousel() {
    const { options } = this.props;
    const self = this;

    Object.assign(options, {
      transitionEnd: self.transitionEnd,
      swiping: self.swiping,
    });

    this.swipe = new Swipe(this.refs.container, options);
  }

  handleInitialLoad() {
    this.setState({ isLoading: false }, this.initCarousel);
  }

  stop() {
    if (this.swipe) {
      this.swipe.stop();
    }
  }

  pause() {
    if (!this.play) {
      this.play = true;
      clearTimeout(this.timeout);
    }
  }

  swiping() {
    this.stopAutoPlay();
  }

  resume() {
    const interval = this.props.options.auto || 0;
    if (!this.play && this.state.autoPlay) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.next, interval);
    }
  }

  pauseSlide() {
    this.stop();
    this.pause();
  }

  resumeSlide() {
    this.play = false;
    this.resume();
  }

  stopAutoPlay() {
    if (this.state.autoPlay) {
      this.setState({
        autoPlay: 0,
      });
      this.setPos();
    }
  }

  slideTo(...args) {
    this.stopAutoPlay();
    this.swipe.slide(...args);
  }

  next() {
    this.swipe.next();
    this.setPos();
  }

  prev() {
    this.swipe.prev();
    this.setPos();
  }

  prevSlide(e) {
    e.preventDefault();
    if (this.state.currentSlide === 0) {
      return;
    }
    this.stopAutoPlay();
    this.prev();
  }

  nextSlide(e) {
    e.preventDefault();
    if ((this.state.currentSlide + 1) >= this.state.numSlides) {
      return;
    }
    this.stopAutoPlay();
    this.next();
  }

  transitionEnd(index, el) {
    const numSlides = this.getNumSlides();
    if (this.props.callback) {
      this.props.callback(index, el);
    }

    this.setState({
      currentSlide: (index >= numSlides) ? (index - numSlides) : index,
      isTransitioning: false,
    });

    if (!this.play && this.state.autoPlay) {
      this.stop();
      this.resume();
    }

    this.setState({ isTransitioning: false });
  }

  renderDotSelectors(itemsLen) {
    const { className, trackId, content } = this.props;
    const { currentSlide } = this.state;
    const activeSlide = (currentSlide >= itemsLen) ? 0 : currentSlide;
    const items = [];
    const listStyle = {
      display: 'inline-block',
      lineHeight: 0,
    };

    for (let i = 0; i < itemsLen; i++) {
      const isActive = (activeSlide === i);
      const selectorClass = cx({
        [`${ORGANISM_NAME}__dot-selector__button`]: true,
        [`${ORGANISM_NAME}__dot-selector__button--active`]: isActive,
        [`${ORGANISM_NAME}__dot-selector__button--transitioning`]: this.state.isTransitioning,
        [`${className}__dot-selector__button`]: className,
        [`${className}__dot-selector__button--active`]: className && isActive,
      });

      items.push(
        <li
          className={`${className}__dot-selector__li`}
          key={`${trackId}-DotSelector-${i}`}
          style={listStyle}
        >
          <button
            aria-label={`${content.goToSlide.text} ${i}`}
            className={selectorClass}
            onFocus = {() => {
              this.pauseSlide();
            }}
            onClick={() => {
              this.slideTo(i); this.setState({ isTransitioning: true });
            }}
            data-pa-click={JSON.stringify({
              link: `Carousel-button-${trackId}`,
              event_name: `brc_dotSelectorSlide${i}_clicked`
            })}
            id={`${trackId}-DotSelector-${i}`}
            tabIndex={isActive ? -1 : 0}
          />
        </li>
      );
    }

    return (
      <ul
        onMouseEnter={this.pauseSlide}
        onMouseLeave={this.resumeSlide}
        className={`${className}__dot-selector ${ORGANISM_NAME}__dot-selector`}
      >
        {items}
      </ul>
    );
  }

  renderSlideCounter(itemsLen) {
    const { className } = this.props;
    const { currentSlide } = this.state;
    const activeSlide = (currentSlide >= itemsLen) ? 1 : currentSlide + 1;

    return (
      <span
        className={`${className}__slide-counter ${ORGANISM_NAME}__slide-counter`}
      >
      {`${activeSlide} / ${itemsLen}`}
      </span>
    );
  }

  render() {
    const { id, className, styles, trackId, content } = this.props;
    const leftClass = cx({
      [`${ORGANISM_NAME}__arrow`]: true,
      [`${ORGANISM_NAME}__arrow__left`]: true,
      [`${ORGANISM_NAME}__arrow__left--disabled`]: (this.state.currentSlide === 0),
      [`${className}__arrow`]: className,
      [`${className}__arrow__left`]: className,
      [`${className}__arrow__left--disabled`]: className && (this.state.currentSlide === 0),
    });

    const rightClass = cx({
      [`${ORGANISM_NAME}__arrow`]: true,
      [`${ORGANISM_NAME}__arrow__right`]: true,
      [`${ORGANISM_NAME}__arrow__right--disabled`]:
        (this.state.currentSlide + 1 >= this.state.numSlides),
      [`${className}__arrow`]: className,
      [`${className}__arrow__right`]: className,
      [`${className}__arrow__right--disabled`]:
        className && (this.state.currentSlide + 1 >= this.state.numSlides),
    });
    const children = React.Children.map(this.props.children, child => {
      let element ='';
      if(child.props.index !== this.state.currentSlide) {
        element = React.cloneElement(child, { style: styles.child, ariaHidden: 'true'});
      }else{
        element = React.cloneElement(child, { style: styles.child, ariaHidden: 'false' });
      }
      return element;
    });

    const wrapperClasses = cx({
      [`${ORGANISM_NAME}__wrapper--no-js`]: this.state.isLoading,
    },
      `${ORGANISM_NAME}__wrapper`,
      `${className}__wrapper`
    );

    return (
      <div
        className={`${ORGANISM_NAME} ${className}`}
      >
        <div
          ref="container"
          id={id}
          style={styles.container}
          onMouseEnter={this.pauseSlide}
          onMouseLeave={this.resumeSlide}
          onClick={this.stopAutoPlay}
        >
          <div className={wrapperClasses} style={styles.wrapper}>
            {this.state.isLoading ? children[0] : children}
          </div>
        </div>
        {this.props.children.length > 1 &&
          <div>
            <button
              aria-label={content.goToNextSlide.text}
              className={rightClass}
              href="#" onClick={this.nextSlide}
              data-pa-click={JSON.stringify({
                link: `Carousel-button-${trackId}`,
                event_name: `brc_rtArrowSlide${this.state.currentSlide}_clicked`
              })}
              tabIndex={this.state.currentSlide + 1 >= this.state.numSlides ? -1 : 0}
              id={`${trackId}-RtArrow-${this.state.currentSlide}`}
            />
            <button
              aria-label={content.goToPreviousSlide.text}
              className={leftClass}
              href="#" onClick={this.prevSlide}
              data-pa-click={JSON.stringify({
                link: `Carousel-button-${trackId}`,
                event_name: `brc_lftArrowSlide${this.state.currentSlide}_clicked`
              })}
              id={`${trackId}-LftArrow-${this.state.currentSlide}`}
              tabIndex={this.state.currentSlide === 0 ? -1 : 0}
            />
          </div>
        }
          {this.props.children.length > 1 && (
            this.props.renderNumberCounter ||
              this.props.children.length > this.props.numberCounterThreshold
                ?
                  this.renderSlideCounter(this.props.children.length)
                :
                  this.renderDotSelectors(this.props.children.length)
            )
          }
      </div>
    );
  }
}

Carousel.propTypes = {
  content: PropTypes.shape({
    goToSlide: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }),
    goToNextSlide: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }),
    goToPreviousSlide: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }),
  }),
  styles: PropTypes.shape({
    container: PropTypes.object,
    wrapper: PropTypes.object,
    child: PropTypes.object,
  }),
  options: PropTypes.shape({
    auto: PropTypes.number,
  }),
  callback: PropTypes.func,
  className: PropTypes.string.isRequired,
  trackId: PropTypes.string.isRequired,
  numberCounterThreshold: PropTypes.number,
  renderNumberCounter: PropTypes.bool,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
};
